<ng-container>
    <div class="center title">
        <strong>{{'admin.partNumbers.form.labels.partnumberOverview' | translate }}</strong>
    </div>
    <div class="items">
        <div *ngIf="this.affectedTools.length > 0"
             class="affectedTools">
            <div>
                <div class="title">
                    <strong>{{'admin.partNumbers.form.labels.affectedTools' | translate}}</strong>
                    <app-tooltip type="warning"
                                 [tooltipPosition]="'down'"
                                 [record]="'admin.partNumbers.form.tooltips.affectedTools' | translate">
                    </app-tooltip>
                </div>
                <app-tool-scan-tree
                    [mode]="'display'"
                    [items]="this.affectedTools || []"
                    [loading]="false"
                    [isScanListenerActive]="false"
                    [isMaterial]="false" >
                </app-tool-scan-tree>
            </div>
        </div>
        <div class="details">
            <div class="title">
                <strong>{{'admin.partNumbers.form.labels.details' | translate }}</strong>
            </div>
            <app-display-label
                label="{{'admin.partNumbers.form.labels.name' | translate }}:"
                [value]="partNumber?.name"
                [inlineLabel]="true">
            </app-display-label>
            <app-display-label
                label="{{'admin.partNumbers.form.labels.description' | translate }}:"
                [value]="partNumber?.description"
                [inlineLabel]="true">
            </app-display-label>
            <app-display-label
                label="{{'admin.partNumbers.form.labels.sapFamily' | translate }}:"
                [value]="partNumber?.sapFamily"
                [inlineLabel]="true">
            </app-display-label>
            <app-display-label
                label="{{'admin.partNumbers.form.labels.sapGroup' | translate }}:"
                [value]="partNumber?.sapGroup"
                [inlineLabel]="true">
            </app-display-label>
            <app-display-label
                label="{{'admin.partNumbers.form.labels.valueStream' | translate }}:"
                [value]="partNumber?.valueStream"
                [inlineLabel]="true">
            </app-display-label>
        </div>
        <div class="linesEquipment">
            <div class="title">
                <strong>{{'admin.partNumbers.form.labels.linesAndEquipment' | translate }}</strong>
            </div>
            <div>
                <label class="atom-label">{{'admin.partNumbers.form.labels.lines' | translate }}:</label>
                <div *ngFor="let line of partNumber?.lines" class="offset-left">
                    <strong>{{ line.name }} </strong>
                </div>
            </div>
            <div>
                <label class="atom-label">{{'admin.partNumbers.form.labels.equipment' | translate }}:</label>
                <div *ngFor="let equipment of partNumber?.equipment" class="offset-left">
                    <strong>{{ equipment.name }} </strong>
                </div>
            </div>
            <div *ngIf="partNumber?.insertionCycles?.length > 0">
                <label class="atom-label">{{'admin.partNumbers.form.labels.insertionCycles' | translate }}:</label>
                <div *ngFor="let line of partNumber?.insertionCycles" class="offset-left">
                    <strong>{{ line.name }} </strong>
                </div>
            </div>
            <div *ngIf="partNumber?.equivalentPartNumbers?.length > 0">
                <label class="atom-label">{{'admin.partNumbers.form.labels.equivalence' | translate }}:</label>
                <div *ngFor="let pn of partNumber?.equivalentPartNumbers" class="offset-left">
                    <strong>{{ pn.nameWithSAP }} </strong>
                </div>
            </div>
        </div>
        <div class="tools">
            <div>
                <div class="title">
                    <strong>{{'admin.partNumbers.form.labels.tools' | translate }}</strong>
                </div>
                <div>
                    <app-tool-scan-tree
                        [mode]="'display'"
                        [items]="this.partNumber?.tools || []"
                        [loading]="false"
                        [isScanListenerActive]="false"
                        [isMaterial]="false" >
                    </app-tool-scan-tree>
                </div>
            </div>
        </div>
    </div>
</ng-container>
